import { alphaColor } from "../../../utils/colors";
export default theme => ({
  root: {
    appearance: 'none',
    border: 'none',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.textDark.secondary,
    pointerEvents: 'none',
    cursor: 'pointer',
    outline: 'none'
  },
  icon: {
    transition: 'all .2s ease',
    color: alphaColor(theme.colors.primary.white, 0.4),
    '&:hover': {
      color: theme.colors.primary.white
    }
  },
  toggleSidebarTooltip: {
    pointerEvents: 'none'
  },
  isExpanded: {
    '& $icon': {
      transform: 'scale3d(-1,1,1)'
    }
  },
  isVisible: {
    pointerEvents: 'auto'
  }
});